import { render, staticRenderFns } from "./jiajuMain.vue?vue&type=template&id=29c180a8&scoped=true"
import script from "./jiajuMain.vue?vue&type=script&lang=js"
export * from "./jiajuMain.vue?vue&type=script&lang=js"
import style0 from "./jiajuMain.vue?vue&type=style&index=0&id=29c180a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c180a8",
  null
  
)

export default component.exports